import {
  ArrowIcon,
  CloseIcon,
  DirectionIcon,
  EmailIcon,
  HeartIcon,
  InstagramIcon,
  MapPinIcon,
  MapIcon,
  RecentIcon,
  SearchIcon,
  StartIcon,
} from "../ui/atoms"

export const BASE_ICON_MAP = {
  email: EmailIcon,
  instagram: InstagramIcon,
  mapFill: MapPinIcon,
  heart: HeartIcon,
  search: SearchIcon,
  start: StartIcon,
  map: MapIcon,
  arrow: ArrowIcon,
  recent: RecentIcon,
  close: CloseIcon,
  direction: DirectionIcon,
} as const

